import CompletenessIndicator from "@/components/CompletenessIndicator/CompletenessIndicator";
import { Flex, Space } from "antd";
import MetricSelect from "@/pages/dashboard/components/MetricSelector/MetricSelect";
import { TreeSelectProps } from "antd/es/tree-select";

export default function MetricSelector(props: TreeSelectProps) {
  return (
    <Flex
      style={{ marginBottom: 24 }}
      justify="space-between"
    >
      <Space>
        <MetricSelect {...props} />
      </Space>
      <CompletenessIndicator />
    </Flex>
  );
}
